/* eslint-disable prefer-object-spread */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-unused-expressions */
import axios from '../axios';
import { checkResponse, getProjectId, getToken } from '../utils';
import { apiV1 } from '../utils/constant';
import { getProjectInfo, clearSessionProject } from './project';
import { createStore, getProjectById, setProject, dbTransaction, getById } from '../dbs/index';

// function clearSessionProject(asyncFunc) {
//   return (...params) => {
//     sessionStorage.removeItem(`/api/v1/projects/${getProjectId()}`);
//     return asyncFunc(...params);
//   };
// }

async function nodeDataInit(storeName, nodes) {
  await dbTransaction(storeName, async (tx) => {
    const store = tx.objectStore(storeName);
    await store.clear();
    await Promise.all(nodes.map((p) => store.add(p)));
    // console.log('nodeDataInit', res);
    await tx.done;
  });
  return nodes;
}

async function areaNodeInit(storeName) {
  // console.log('areaNodeInit');
  const areaPromise = getAreaData({
    params: {
      as: 'nodes',
      status: true,
    },
  });

  const keyPath = 'value';
  await createStore(storeName, null, { keyPath, autoIncrement: false });
  const { nodes } = await areaPromise;
  return nodeDataInit(storeName, nodes);
}

async function eachAllNodes(storeName, { whereFunc, selectFunc }) {
  return dbTransaction(storeName, async (tx) => {
    let cursor = await tx.objectStore(storeName).openCursor();

    const arr = [];
    while (cursor) {
      // console.log(cursor.key, cursor.value);
      if (whereFunc(cursor.value)) {
        arr.push(selectFunc(cursor.value));
      }
      cursor = await cursor.continue();
    }
    return arr;
  });
}

function createSelectFunc({ no, has } = {}) {
  if (has) {
    return (node) => {
      for (const key of Object.keys(node)) {
        has.includes(key) || Reflect.deleteProperty(node, key);
      }
      return node;
    };
  }
  if (no) {
    return (node) => {
      no.forEach((p) => {
        Reflect.deleteProperty(node, p);
      });
      return node;
    };
  }
  return null;
}

/**
 * @function getAreas
 * @desc 获取点位列表
 * @returns {Object}
 */
async function getAreasCache(funcs = {}) {
  funcs.selectFunc || (funcs.selectFunc = (node) => node);
  funcs.whereFunc || (funcs.whereFunc = () => true);
  // 获取当前节点的最后更新时间
  const newProject = await getProjectInfo();
  newProject.areaLastUpdatedAt = new Date(newProject.areaLastUpdatedAt || 0);
  const currProject = await getProjectById(newProject.id);
  // console.log('getAreasCache', currProject);
  let areas;
  const storeName = `areas-${newProject.id}`;
  if (
    // 没有存储过Project
    !currProject ||
    // 版本过期
    (currProject.fetchAt || 0) < 1608111873661 ||
    // areaLastUpdatedAt未更新过
    Number.isNaN(currProject.areaLastUpdatedAt.getTime()) ||
    // areaLastUpdatedAt更新时间过期
    newProject.areaLastUpdatedAt > currProject.areaLastUpdatedAt
  ) {
    // 执行area请求
    areas = await areaNodeInit(storeName);
    newProject.fetchAt = Date.now();
    await setProject(newProject);
    areas = areas.filter(funcs.whereFunc).map(funcs.selectFunc);
  } else {
    areas = await eachAllNodes(storeName, funcs);
  }
  return areas.sort((a, b) => a.orderBy - b.orderBy);
}

function toTree(nodes) {
  const map = {};
  const roots = [];
  nodes.forEach((p) => {
    map[p.value] || (map[p.value] = { children: [] });
    Object.assign(map[p.value], p);
    if (p.parentId) {
      map[p.parentId] || (map[p.parentId] = { children: [] });
      map[p.parentId].children.push(map[p.value]);
    } else {
      roots.push(map[p.value]);
    }
  });
  // console.log(roots)
  return roots;
}

async function getNodesAncestors(storeName, nodes) {
  const ids = new Set();
  nodes.forEach((p) => {
    p.ancestors = p.ancestors
      .filter((q) => q)
      .map((q) => {
        const id = Number.parseInt(q, 10);
        ids.add(id);
        return id;
      });
  });
  // console.log(ids);
  const finded = await eachAllNodes(storeName, {
    whereFunc: (node) => ids.has(node.value),
    selectFunc: (node) => [node.value, node.title],
  });
  // console.log(finded);
  const map = new Map(finded);
  // console.log(map);
  nodes.forEach((p) => {
    p.ancestors = p.ancestors.map((q) => map.get(q) || '');
  });
}

async function setNodeAncestors(storeName, node) {
  if (!node.ancestors || !node.ancestors.length) {
    return;
  }
  const ancestors = await Promise.all(
    node.ancestors.map((p) => getById(storeName, Number.parseInt(p || 0, 10))),
  );
  node.ancestors = ancestors.filter((p) => p).map((p) => p.title);
}
/**
 *
 * @param {
 * as:'tree'|'nodes'
 * has:[] //'ancestors'//返回值是否包含祖先链
 * leaf:true|false//叶子节点
 * 'ancestors.contains':nodeId//查询祖先链中包含某个节点id
 * } opt 可传参数
 */
async function getAreaListDataCache(opt = {}) {
  // 'as=tree&noImage=true&noGeo=true'
  // 默认返回tree
  const { as = 'tree', has = [] } = opt;
  ['as', 'has'].forEach((p) => Reflect.deleteProperty(opt, p));
  const no = ['image', 'geotype', 'polygon', 'properties'];
  !has.includes('ancestors') && no.push('ancestors');
  const funcs = {
    selectFunc: createSelectFunc({ no }),
  };
  funcs.whereFunc = Object.entries(opt).reduce((pre, [key, val]) => {
    switch (key) {
      case 'ancestors.contains':
        return (node) => {
          const preV = pre ? pre(node) : true;
          return preV && node.ancestors.includes(val);
        };
      default:
        return (node) => {
          const preV = pre ? pre(node) : true;
          return preV && node[key] === val;
        };
    }
  }, null);
  const nodes = await getAreasCache(funcs);
  if (has.includes('ancestors')) {
    const pro = await getProjectInfo();
    const storeName = `areas-${pro.id}`;
    await getNodesAncestors(storeName, nodes);
    // await Promise.all(nodes.map(p => setNodeAncestors(storeName, p)))
  }
  return {
    nodes: as === 'tree' ? toTree(nodes) : nodes,
  };
}

async function getAreaByValue(val) {
  const newProject = await getProjectInfo();
  const storeName = `areas-${newProject.id}`;
  return getById(storeName, val);
}

async function getAreaDataCache(setup = { nocache: false }) {
  return setup.nocache === true
    ? getAreaData()
    : {
        nodes: toTree(
          await getAreasCache({
            selectFunc: createSelectFunc({
              no: ['geotype', 'polygon', 'properties'],
            }),
          }),
        ),
      };
}

async function getGeojsonCache() {
  const newProject = await getProjectInfo();
  return {
    type: 'FeatureCollection',
    name: newProject.title,
    crs: {
      type: 'name',
      properties: {
        name: 'urn:ogc:def:crs:OGC:1.3:CRS84',
      },
    },
    features: await getAreasCache({
      whereFunc: (node) => {
        return node.polygon && node.polygon.length;
      },
      selectFunc: (node) => {
        return {
          type: 'Feature',
          title: node.title,
          properties: Object.assign({ value: node.value }, node.properties),
          geometry: {
            type: node.geotype,
            coordinates: node.polygon,
          },
        };
      },
    }),
  };
}
// getGeojsonCache().then(res => console.log('getGeojsonCache', res))
/**
 * @function getAmongStandards
 * @desc 点击点位获取对应指标
 * @param {Number} projectId 项目id
 * @param {Number} area_id 点位id
 * @returns {Object} 返回对应指标信息
 */
function getAreaAmongStandards(id) {
  return axios
    .get(`${apiV1}/projects/${getProjectId()}/area/standard_binds?area_id=${id}`)
    .then(checkResponse);
}
/**
 * @function bindStandards
 * @desc 绑定指标和点位
 * @param {Number} projectId 项目id
 * @param {Array} areaIds 点位id数组
 * @param {Array} standardIds 指标id数组
 * @returns {Object} 返回绑定成功信息
 */
const bindAreaStandards = clearSessionProject(function bindAreaStandards(data) {
  return axios
    .put(`${apiV1}/projects/${getProjectId()}/area/bind_standards`, data)
    .then(checkResponse);
});

/**
 * @function getAreaData
 * @desc 获取点位列表
 * @param {Number} projectId 项目id
 * @returns {Object} 返回点位列表信息
 */
function getAreaData(data) {
  return axios.get(`${apiV1}/projects/${getProjectId()}/area`, data).then(checkResponse);
}
/**
 * @function getAreaListData
 * @desc 获取点位列表树
 * @param {Number} projectId 项目id
 * @returns {Object} 返回点位列表信息
 */
function getAreaListData() {
  return axios
    .get(`${apiV1}/projects/${getProjectId()}/area?as=tree&noImage=true&noGeo=true`)
    .then(checkResponse);
}
/**
 * @function newAreaData
 * @desc 新建点位列表
 * @param {Number} projectId 项目id
 * @param {Array} nodes 点位名称数组
 * @param {Number} parent_id 父级id
 * @param {Number} area_type_id 点位类型id
 * @returns {Object} 返回点位列表信息
 */
const newAreaData = clearSessionProject(function newAreaData(data) {
  return axios
    .post(`${apiV1}/projects/${getProjectId()}/area/nodes_batch`, data)
    .then(checkResponse);
});
/**
 * @function editAreaData
 * @desc 编辑点位列表
 * @param {Number} projectId 项目id
 * @param {String} title 点位名称
 * @param {Number} title 点位类型id
 * @returns {Object} 返回点位列表信息
 */
const editAreaData = clearSessionProject(function editAreaData(id, data) {
  return axios
    .put(`${apiV1}/projects/${getProjectId()}/area/nodes?node_id=${id}`, {
      data,
    })
    .then(checkResponse);
});

/**
 * @function delAreaData
 * @desc 删除点位列表
 * @param {Number} projectId 项目id
 * @param {Number} node_id 点位id
 * @returns {Object} 返回点位列表信息
 */
const delAreaData = clearSessionProject(function delAreaData(id) {
  return axios
    .delete(`${apiV1}/projects/${getProjectId()}/area/nodes?node_id=${id}`)
    .then(checkResponse);
});

/**
 * @function getAreaType
 * @desc 获取点位列表
 * @returns {Object}
 */
function getAreaType() {
  return axios
    .get(`/api/v1/projects/${getProjectId()}/area/area_types/nodes?as=tree`)
    .then(checkResponse);
}

/**
 * @function getDefaultAreaType
 * @desc 获取默认点位类型
 * @returns {Object}
 */
function getDefaultAreaType() {
  return axios
    .get(`/api/v1/projects/${getProjectId()}/area/area_types/defalut_one?as=node`)
    .then(checkResponse);
}
/**
 * @function getSampleArea
 * @desc 点位示例树
 * @returns {Object}
 */
function getSampleArea() {
  return axios
    .get(`/api/v1/projects/${getProjectId()}/area/sample`)
    .then(checkResponse)
    .then((res) => {
      return res.data;
    });
}
/**
 * @function useSampleArea
 * @desc 使用点位示例
 * @returns {Object}
 */
const useSampleArea = clearSessionProject(function useSampleArea() {
  return axios
    .put(`/api/v1/projects/${getProjectId()}/use_sample`, {
      utype: 'areas',
    })
    .then(checkResponse);
});
/**
 * @function addTextNodesArea
 * @desc 批量添加点位
 * @param {Object} data 点位树
 * @returns {Object}
 */
const addTextNodesArea = clearSessionProject(function addTextNodesArea(data) {
  return axios.post(`/api/v1/projects/${getProjectId()}/area/text_nodes`, data).then(checkResponse);
});
/**
 * @function getAreas
 * @desc 获取点位列表
 * @returns {Object}
 */
function getAreas() {
  return axios.get(`/api/v1/projects/${getProjectId()}/area?as=nodes`).then(checkResponse);
}
/**
 * @function getStageType
 * @desc 获取地块
 * @returns {Object}
 */
function getAreaGeojson() {
  return axios.get(`/api/v1/projects/${getProjectId()}/area/geojson`).then(checkResponse);
}
/**
 * @function getGeojson
 * @desc 获取地块
 * @returns {Object}
 */
function getGeojson() {
  return axios.get(`${apiV1}/projects/${getProjectId()}/area/geojson`).then(checkResponse);
}
/**
 * @function getAreaStatics
 * @desc 点位报案状态统计
 * @param {Number} projectId 项目id
 * @param {Number} month 默认当前月份
 * @param {Number} round 检查轮
 * @returns {Object}
 * @returns {string} inspectedColor 已检查案件颜色
 * @returns {string} uninspectColor 未检查案件颜色
 * @returns {string} uninspectText 未检查状态文字
 * @returns {array} inspectedAreaIds 已检查点位id数组
 */
function getAreaStatics(year, month, round) {
  return axios
    .get(
      `/api/v1/projects/${getProjectId()}/area/statics?year=${year}&month=${month}&round=${round}`,
    )
    .then(checkResponse);
}

/**
 * @function newAreaType
 * @desc 新建点位类型
 * @param {Number} projectId 项目id
 * @param {String} title 点位名称
 * @param {Number} imageId 点位图标id
 * @returns {Object} 返回点位类型信息
 */
function newAreaType(data) {
  return axios
    .post(`${apiV1}/projects/${getProjectId()}/area/area_types/nodes?as=tree`, {
      data,
    })
    .then(checkResponse);
}
/**
 * @function edtiAreaType
 * @desc 编辑点位类型
 * @param {Number} projectId 项目id
 * @param {Number} node_id 类型id
 * @param {String} title 点位名称
 * @param {Number} imageId 点位图标id
 * @returns {Object} 返回点位类型信息
 */
function edtiAreaType(id, data) {
  return axios
    .put(`${apiV1}/projects/${getProjectId()}/area/area_types/nodes?node_id=${id}`, {
      data,
    })
    .then(checkResponse);
}
/**
 * @function delAreaType
 * @desc 删除点位类型
 * @param {Number} projectId 项目id
 * @param {Number} node_id 点位类型id
 * @returns {Object} 返回点位类型信息
 */
function delAreaType(id) {
  return axios
    .delete(`${apiV1}/projects/${getProjectId()}/area/area_types/nodes?node_id=${id}`)
    .then(checkResponse);
}

/**
 * @function getAreaPoint
 * @desc 获取点位
 * @returns {Object}
 */
function getAreaPoint() {
  return axios.get(`/api/v1/projects/${getProjectId()}/area`).then(checkResponse);
}

/**
 * @function getAreaPointTypeId
 * @desc 获取点位类型
 * @returns {Object}
 */
function getAreaPointTypeId() {
  return axios.get(`/api/v1/projects/${getProjectId()}/area/area_types`).then(checkResponse);
}

/**
 * @function getAreaPointType
 * @desc 获取点位类型
 * @returns {Object}
 */
function getAreaPointType(id) {
  return axios
    .get(`/api/v1/projects/${getProjectId()}/area/area_types/${id}?as=node`)
    .then(checkResponse);
}

/**
 * @function getAreaTypeIcon
 * @desc 获取点位图标
 * @returns {Object}
 */
function getAreaTypeIcon(id) {
  return axios
    .get(`${apiV1}/projects/${getProjectId()}/area/area_types/${id}/icons?as=node`)
    .then(checkResponse);
}
/**
 * @function getNavPoints
 * @desc 获取巡检点位
 * @returns {Object}
 */
function getNavPoints(node) {
  return axios
    .get(`${apiV1}/projects/${getProjectId()}/area/nav_points?node_id=${node}`)
    .then(checkResponse);
}
/**
 * @function addNavPoints
 * @desc 新增巡检点位
 * @returns {Object}
 */
function addNavPoints(node, data) {
  return axios
    .post(`${apiV1}/projects/${getProjectId()}/area/nav_points?node_id=${node}`, data)
    .then(checkResponse);
}
/**
 * @function delNavPoints
 * @desc 删除巡检点位
 * @returns {Object}
 */
function delNavPoints(params) {
  return axios
    .delete(`${apiV1}/projects/${getProjectId()}/area/nav_points`, { params })
    .then(checkResponse);
}
/**
 * @function startNavPoints
 * @desc 开启巡检点位
 * @returns {Object}
 */
function startNavPoints() {
  return axios.put(`${apiV1}/projects/${getProjectId()}/area/start_nav_points`).then(checkResponse);
}
/**
 * @function delAreaBatch
 * @desc 批量删除点位
 * @returns {Object}
 */
const delAreaBatch = clearSessionProject(function delAreaBatch(params) {
  return axios
    .delete(`${apiV1}/projects/${getProjectId()}/area/nodes_batch`, { params })
    .then(checkResponse);
});

/**
 * @function orderArea
 * @desc 点位排序
 * @returns {Object}
 */
const orderArea = clearSessionProject(function orderArea(data) {
  return axios
    .put(`${apiV1}/projects/${getProjectId()}/area/order_nodes`, data)
    .then(checkResponse);
});

/**
 * @function updateAreaStatus
 * @desc 点位启用、禁用
 * @param {Number} projectId 项目id
 * @returns
 */
// function updateAreaStatus(id, status) {
//   return axios
//     .put(`${apiV1}/projects/${getProjectId()}/area/nodes_status?node_id=${id}&status=${status}`)
//     .then(checkResponse);
// }

const updateAreaStatus = clearSessionProject(function updateAreaStatus(id, status) {
  return axios
    .put(`${apiV1}/projects/${getProjectId()}/area/nodes_status?node_id=${id}&status=${status}`)
    .then(checkResponse);
});
/**
 * @function importAreas
 * @desc 点位导出
 * @param {Number} projectId 项目id
 * @returns
 */
function importAreas() {
  return `${apiV1}/projects/${getProjectId()}/area/export?token=${getToken()}`;
}

export {
  getAreaAmongStandards,
  bindAreaStandards,
  getAreaDataCache as getAreaData,
  getAreaListDataCache as getAreaListData,
  getAreaByValue,
  newAreaData,
  editAreaData,
  delAreaData,
  getAreaType,
  getDefaultAreaType,
  getSampleArea,
  useSampleArea,
  addTextNodesArea,
  getAreas,
  getGeojsonCache as getAreaGeojson,
  getGeojsonCache as getGeojson,
  getAreaStatics,
  newAreaType,
  edtiAreaType,
  delAreaType,
  getAreaPoint,
  getAreaPointTypeId,
  getAreaPointType,
  getAreaTypeIcon,
  getNavPoints,
  addNavPoints,
  delNavPoints,
  startNavPoints,
  delAreaBatch,
  orderArea,
  updateAreaStatus,
  importAreas,
};
